import React, { useState, useEffect } from "react";
import { capitalizeWords } from './helper/CapitalizeWords'
import { FormatMoney } from '../../../Helpers/FormatNumber'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { ModalImagen } from './ModalImagen';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import SaveIcon from '@mui/icons-material/Save';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import { ModalCarruselImagenes } from "./ModalCarruselImagenes";
import CollectionsIcon from '@mui/icons-material/Collections';

export const TablaConfiguracionImagenesContainer = ({ datos, ObtenerListado, filtrar, setFiltrar, setKeyFiltrado }) => {
    const [openModal, setOpenModal] = useState(false);
    const [openModalCarrusel, setOpenModalCarrusel] = useState(false);
    const [imagenes, setImagenes] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [nuevaData, setNuevaData] = useState([])

    const handleOpen = async (rowData) => {
        setSelectedRow(rowData);
        setLoader({ ...loader, mostrar: true });

        try {
            const result = await request.get(`ImagenesMaquinaria/BuscarImagenes?idinventario=${rowData.idinventario}`);

            if (result && result.length > 0) {
                setImagenes(result);
                setOpenModal(true);
                setLoader({ ...loader, mostrar: false });
            } else {
                setImagenes([]);
                setOpenModal(true);
                setLoader({ ...loader, mostrar: false });
            }
        } catch (error) {
            console.error(error);
            setOpenModal(true);
        }
    };


    const handleClose = () => setOpenModal(false);

    const onEstatus = (estatus) => {
        if (estatus === "L") {
            return "info-estatus-circulo circulo-verde"
        }
        else if (estatus === "A") {
            return "info-estatus-circulo circulo-amarillo"
        }
        else if (estatus === "V") {
            return "info-estatus-circulo circulo-rojo"
        }
    }

    const formatWithCommas = (value) => {
        if (!value) return '';
        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    // console.log(nuevaData)

    const onFiltrar = (filtro) => {
        setFiltrar(!filtrar)
        setKeyFiltrado(filtro)
    }

    const handleOpenCarrusel = async (rowData) => {
        if (rowData.tiene_imagen === "N") {
            return;
        }
        else {
            setSelectedRow(rowData);
            setLoader({ ...loader, mostrar: true });

            try {
                const result = await request.get(`ImagenesMaquinaria/BuscarImagenes?idinventario=${rowData.idinventario}`);

                if (result && result.length > 0) {
                    setImagenes(result);
                    setOpenModalCarrusel(true);
                    setLoader({ ...loader, mostrar: false });
                } else {
                    Swal.fire("Imagenes", "Este tractor no cuenta con imagenes", "warning");
                    setLoader({ ...loader, mostrar: false });
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const handleCloseCarrusel = () => setOpenModalCarrusel(false);

    const getMonthName = (dateString) => {
        const currentDate = new Date();  // Obtiene la fecha actual
        const currentMonth = currentDate.getMonth();  // Obtiene el número de mes (0 - 11)

        if (!dateString) return '';

        const [day, month, year] = dateString.split('/');
        const monthNames = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];

        // Concatenamos el nombre del mes actual y el mes del dateString
        return monthNames[currentMonth] + ' - ' + monthNames[parseInt(month) - 1];
    };

    const totalPrecio = datos.reduce((sum, item) => sum + item.precio, 0);
    const totalCosto = datos.reduce((sum, item) => sum + item.costo, 0);
    const totalOt = datos.reduce((sum, item) => sum + item.ot, 0);
    const totalUtilidad = datos.reduce((sum, item) => sum + (item.utilidad || 0), 0);
    const totalPrecioLista = datos.reduce((sum, item) => sum + (item.precio_lista || 0), 0);
    const margenTotal = totalCosto !== 0 ? (totalUtilidad / totalCosto) * 100 : 0;

    return (
        <div className="listado-precios-container">
            <LoaderScreen loader={loader} />
            <div className="listado-precios-configuracion-container-table scroll">
                <table cellSpacing={0} cellPadding={0}>
                    <thead>
                        <tr>
                            <th></th>
                            <th>

                            </th>
                            <th></th>
                            <th>
                                EQUIPO
                            </th>
                            <th>
                                <div>N.E</div>
                            </th>
                            <th>
                                <div>MARCA</div>
                            </th>
                            <th>
                                <div>AÑO</div>
                            </th>
                            <th>
                                <div>HP</div>
                            </th>
                            <th>
                                <div>HORAS</div>
                            </th>
                            <th>
                                <div>PRECIO</div>
                            </th>
                            <th>
                                <div>PROMOCION</div>
                            </th>
                            <th>
                                <div>ESTATUS</div>
                            </th>
                            <th>
                                <div>SUCURSAL</div>
                            </th>
                            
                            <th>
                                <div>IMAGENES</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                    {datos.map((datos, index) => (
                            <tr>
                                <td className="celda-numero celda-fija-numero">{index + 1}</td>
                                <td className="celda-circulo celda-fija">
                                    <div className={onEstatus(datos.estatus)}></div>
                                </td>
                                <td className="celda-img celda-fija-img"><div className={datos.tiene_imagen === "S" ? "img" : "img-sin-color"} onClick={() => handleOpenCarrusel(datos)}><CollectionsIcon /></div></td>
                                <td className="celda-modelo celda-fija-3">{datos.modelo_descripcion}</td>
                                <td className="celda-numecon celda-fija-4">{datos.ne}</td>
                                <td className="celda-marca ta-center">{datos.marca = 'JD' ? 'JOHN DEERE' : datos.marca}</td>
                                <td className='celda-chica'>{datos.ejercicio}</td>
                                <td className='celda-chica'>{datos.hp}</td>
                                <td className='celda-chica'>{datos.horas}</td>
                                <td className='celda-importe'>{FormatMoney(datos.precio_lista)}</td>
                                <td className="celda-promocion">
                                    {datos.promocion ? datos.promocion.toUpperCase() : ''}
                                    <br/>
                                    {datos.vigencia}
                                </td>
                                <td className='celda-estatus'>{datos.estatus === "L" ? "LISTO PARA LA VENTA" : datos.estatus === "A" ? "ACONDICIONANDO" : "NO IDENTIFICADO"}</td>
                                {/* <td className='celda-chica'>{getMonthName(datos.vigencia)}</td> */}
                                <td className="celda-sucursal ta-center">{datos.nombre_sucursal}</td>
                                
                                <td className='celda-button'>
                                    <div className="imagenes-button" onClick={() => handleOpen(datos)} style={{ cursor: "pointer" }}>
                                        <AddPhotoAlternateIcon />
                                        Imágenes
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="listado-precios-footer-container">
                <div className="listado-precios-info-container">
                    <div className="info-estatus">

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("L")}>
                            <div className="info-estatus-circulo circulo-verde"></div>
                            Listo para la venta
                        </div>

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("A")}>
                            <div className="info-estatus-circulo circulo-amarillo"></div>
                            Acondicionando
                        </div>

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("T")}>
                            <div className="info-estatus-circulo circulo-dividido"></div>
                            Todos
                        </div>
                    </div>
                </div>

            </div>
            <ModalImagen open={openModal} handleClose={handleClose} datos={selectedRow} imagenesBD={imagenes} />
            <ModalCarruselImagenes open={openModalCarrusel} handleClose={handleCloseCarrusel} datos={selectedRow} imagenesBD={imagenes} />
        </div>
    )
}
